var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 45H17.5C8.68 45 6 42.32 6 33.5V13.5C6 4.7 8.68 2 17.5 2H29.5C38.32 2 41 4.68 41 13.5V33.5C41 42.32 38.32 45 29.5 45ZM17.5 5C10.36 5 9 6.34 9 13.5V33.5C9 40.66 10.36 42 17.5 42H29.5C36.64 42 38 40.66 38 33.5V13.5C38 6.34 36.64 5 29.5 5H17.5Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4999 39.2C20.9599 39.2 18.8999 37.14 18.8999 34.6C18.8999 32.06 20.9599 30 23.4999 30C26.0399 30 28.0999 32.06 28.0999 34.6C28.0999 37.14 26.0399 39.2 23.4999 39.2ZM23.4999 33C22.6199 33 21.8999 33.72 21.8999 34.6C21.8999 35.48 22.6199 36.2 23.4999 36.2C24.3799 36.2 25.0999 35.48 25.0999 34.6C25.0999 33.72 24.3799 33 23.4999 33Z",
    fill: "#03182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.12 25.42C23.78 25.54 23.22 25.54 22.88 25.42C19.98 24.42 13.5 20.24 13.5 13.16C13.5 10.04 15.98 7.5 19.06 7.5C20.88 7.5 22.48 8.38 23.5 9.76C24.52 8.38 26.14 7.5 27.94 7.5C31.02 7.5 33.5 10.02 33.5 13.16C33.5 20.24 27.02 24.42 24.12 25.42Z",
    fill: "#FF2B26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHeart);
export default __webpack_public_path__ + "static/media/mobile-heart.0b85db795087d143a87bba507cc92b25.svg";
export { ForwardRef as ReactComponent };